import { call } from 'redux-saga/effects';
import appHandler from '../appHandler';
import { APIHandler, handleError } from '../commonHandlers';
import { handleGetScheduleDepositionsSuccess } from './depositionHandler';

function* getScheduleDepositions(api, action) {
  const response = yield call(api, action.payload);
  appHandler.route(action, response, handleGetScheduleDepositionsSuccess, handleError);
}

function* updateScheduleDeposition(api, action) {
  yield call(APIHandler, api, action);
}

export default {
  getScheduleDepositions,
  updateScheduleDeposition,
};
